import React from 'react';
import { formatPrice } from '../../../utils/string.ts';

export type PriceProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
  price: number;
  children?: React.ReactNode;
  className?: string;
  fractionDigits?: number;
  currency?: string;
};

export const Price: React.FunctionComponent<PriceProps> = props => {
  const { price, children, className, fractionDigits, currency = '€', ...htmlAttributes } = props;

  return (
    <span {...htmlAttributes} className={className}>
      {currency} {formatPrice(price, fractionDigits)} {children}
    </span>
  );
};
